import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {APP_BASE_HREF} from '@angular/common';
import {appRoutingProviders, routing} from './app.routes';
import {AppComponent} from './app.component';
import {HttpTokenService} from './ecare-parent/services/http_token_service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {DashboardComponent} from './ecare-parent/dashboard/dashboard.component';
import {DashboardResolve} from './ecare-parent/dashboard/dashboard.resolve';
import {LoginComponent} from './login/login.component';
import {CookieModule, CookieService} from 'ngx-cookie';
import {HeaderComponent} from './ecare-parent/header/header.component';
import {NavigatorComponent} from './ecare-parent/navigator/navigator.component';
import {FooterComponent} from './ecare-parent/footer/footer.component';
import {AuthGuard} from './auth2-guard/auth.guard';
import {EcareSecurityService} from './ecare-parent/services/ecare_security_service';
import {ClientService} from './ecare-parent/services/client.service';
import {UserPreferenceService} from './ecare-parent/services/user.preferences.service';
import {InterceptableHttp} from './ecare-parent/services/InterceptableHttp';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AngularFireModule} from '@angular/fire';
import { DatePipe } from '@angular/common';

import {
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule, MatProgressBarModule, MatProgressSpinnerModule,
    MatRadioModule, MatSidenavModule,
    MatStepperModule,
    MatToolbarModule
} from '@angular/material';
import {MatSelectModule} from '@angular/material/select';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTabsModule} from '@angular/material/tabs';
import {DisableDirective} from './ecare-parent/directives/disable.directive';
import {ErrorComponent} from './ecare-parent/error/error.component';
import {SidebarComponent} from './ecare-parent/sidebar/sidebar.component';
import {SidebarService} from './ecare-parent/sidebar/sidebar.service';
import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {BsDatepickerConfig, BsDatepickerModule, BsDropdownModule} from 'ngx-bootstrap';
import {AngularFontAwesomeModule} from 'angular-font-awesome';
import {LiveDataComponent} from './ecare-parent/live-data/live-data.component';
import {LiveDataResolve} from './ecare-parent/live-data/live-data.resolve';
import {LiveChartDirective} from './ecare-parent/directives/live-chart.directive';
import {SensordataComponent} from './ecare-parent/sensordata/sensordata.component';
import {SensorModelComponent, UserModelComponent} from './ecare-parent/models/models.component';
import {PackageViewComponent} from './ecare-parent/package/package-view/package-view.component';
import {PackageFormComponent} from './ecare-parent/package/package-form/package-form.component';
import {ClientViewComponent} from './ecare-parent/client/client-view/client-view.component';
import {ClientFormComponent} from './ecare-parent/client/client-form/client-form.component';
import {EcareParentComponent} from './ecare-parent/ecare-parent.component';
import {ClientteamFormComponent} from './ecare-parent/clientteam/clientteam-form/clientteam-form.component';
import {ClientteamViewComponent} from './ecare-parent/clientteam/clientteam-view/clientteam-view.component';
import {ClientinventoryViewComponent} from './ecare-parent/clientinventory/clientinventory-view/clientinventory-view/clientinventory-view.component';
import {ToastrModule} from 'ngx-toastr';
import {OrderFormComponent} from './ecare-parent/order/order-form/order-form.component';
import {OrderViewComponent} from './ecare-parent/order/order-view/order-view.component';
import {PatientViewComponent} from './ecare-parent/patient/patient-view/patient-view.component';
import {PatientFormComponent} from './ecare-parent/patient/patient-form/patient-form.component';
import {CampaignFormComponent} from './ecare-parent/campaign/campaign-form/campaign-form.component';
import {CampaignViewComponent} from './ecare-parent/campaign/campaign-view/campaign-view.component';
import {ProvisionFormComponent} from './ecare-parent/order/provision-form/provision-form.component';
import {UserViewComponent} from './ecare-parent/user/user-view/user-view/user-view.component';
import {LiveDataView} from './ecare-parent/live-data-view/live-data-view.model';
import {NgxPaginationModule} from 'ngx-pagination';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {DeviceViewComponent} from './ecare-parent/device-view/device-view.component';
import {EventLogViewComponent} from './ecare-parent/eventlog/eventlog-view.component';
import {DataAvailabilityViewComponent} from './ecare-parent/data-availability/data-availability-view/dataavailability-view.component';

import {CampaigncontactFormComponent} from './ecare-parent/campaigncontact/campaigncontact-form/campaigncontact-form/campaigncontact-form.component';
import {CampaigncontactViewComponent} from './ecare-parent/campaigncontact/campaigncontact-view/campaigncontact-view.component';
import {UserFormComponent} from './ecare-parent/user/user-form/user-form.component';
import {RoleFormComponent} from './ecare-parent/role/role-form/role-form.component';
import {RoleViewComponent} from './ecare-parent/role/role-view/role-view.component';
import {AuthenticationViewComponent} from './ecare-parent/authentication/authentication-view/authentication-view.component';
import {AuthenticationFormComponent} from './ecare-parent/authentication/authentication-form/authentication-form.component';
import {FirmwareFormComponent} from './ecare-parent/firmware/firmware-form/firmware-form/firmware-form.component';
import {FirmwareViewComponent} from './ecare-parent/firmware/firmware-view/firmware-view/firmware-view.component';
import {FilterViewComponent} from './ecare-parent/filters/filter-view/filter-view.component';
import {FilterFormComponent} from './ecare-parent/filters/filter-form/filter-form.component';
import {AlgorithmConfigFormComponent} from './ecare-parent/algorithm-config/algorithm-config-form/algorithm-config-form.component';
import {AlgorithmConfigViewComponent} from './ecare-parent/algorithm-config/algorithm-config-view/algorithm-config-view.component';
import {HistoryDataComponent} from './ecare-parent/history-data/history-data.component';
import {HistoryDataViewModel} from './ecare-parent/history-data-view/history-data-view.model';
import {ReportViewComponent} from './ecare-parent/report/report-view/report-view.component';
import {ReportFormComponent} from './ecare-parent/report/report-form/report-form.component';
import {OwlDateTimeModule, OwlNativeDateTimeModule} from 'ng-pick-datetime';
import { PhysicianViewComponent } from './ecare-parent/physician/physician-view/physician-view.component';
import { ViewTransactionComponent } from './ecare-parent/transaction/view-transaction/view-transaction.component';
import {NgSelectModule} from '@ng-select/ng-select';
import { AppointmentComponent } from './ecare-parent/appointment/appointment.component';
import { AppointmentTransactionComponent } from './ecare-parent/appointment/appointment-transaction/appointment-transaction.component';
import { PhysicianTransactionComponent } from './ecare-parent/physician/physician-transaction/physician-transaction.component';
import { PhysicianDetailsComponent } from './ecare-parent/physician/physician-details/physician-details.component';
import { PhysicianDocumentViewComponent } from './ecare-parent/physician/physician-document-view/physician-document-view.component';
import { environment } from '../environments/environment';
import {AngularFireDatabaseModule} from '@angular/fire/database';
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { PhysicisanReviewCommentsComponent } from './ecare-parent/physician/physicisan-review-comments/physicisan-review-comments.component';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { CommissionComponent } from './ecare-parent/physician/commission/commission.component';
import { AddCommissionComponent } from './ecare-parent/physician/commission/add-commission/add-commission.component';
import { UnpublishedCommentsComponent } from './ecare-parent/physician/physicisan-review-comments/unpublished-list/unpublished-comments.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    LoginComponent,
    HeaderComponent,
    NavigatorComponent,
    FooterComponent,
    DisableDirective,
    ErrorComponent,
    SidebarComponent,
    LiveDataComponent,
    LiveChartDirective,
    SensordataComponent,
    UserModelComponent,
    SensorModelComponent,
    PackageViewComponent,
    PackageFormComponent,
    ClientViewComponent,
    ClientFormComponent,
    EcareParentComponent,
    ClientteamFormComponent,
    ClientteamViewComponent,
    ClientinventoryViewComponent,
    PatientViewComponent,
    PatientFormComponent,
    OrderFormComponent,
    OrderViewComponent,
    CampaignFormComponent,
    CampaignViewComponent,
    ProvisionFormComponent,
    UserViewComponent,
    EventLogViewComponent,
    DataAvailabilityViewComponent,
    DeviceViewComponent,
    CampaigncontactFormComponent,
    CampaigncontactViewComponent,
    UserFormComponent,
    RoleFormComponent,
    RoleViewComponent,
    AuthenticationViewComponent,
    AuthenticationFormComponent,
    FirmwareFormComponent,
    FirmwareViewComponent,
    FilterViewComponent,
    FilterFormComponent,
    AlgorithmConfigFormComponent,
    AlgorithmConfigViewComponent,
    HistoryDataComponent,
    ReportViewComponent,
    ReportFormComponent,
    PhysicianViewComponent,
    ViewTransactionComponent,
    AppointmentComponent,
    AppointmentTransactionComponent,
    PhysicianTransactionComponent,
    PhysicianDetailsComponent,
    PhysicianDocumentViewComponent,
    PhysicisanReviewCommentsComponent,
    CommissionComponent,
    AddCommissionComponent,
    UnpublishedCommentsComponent,
  ],
    imports: [
        BrowserModule,
        HttpModule,
        // RouterModule.forRoot(AppRoutes, { enableTracing: false }),
        CookieModule.forRoot(),
        ToastrModule.forRoot(),
        MatNativeDateModule,
        MatDatepickerModule,
        MatIconModule,
        MatButtonModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatDialogModule,
        FormsModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatRadioModule,
        MatSidenavModule,
        MatSelectModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatTabsModule,
        NgSelectModule,
        BrowserAnimationsModule,
        BsDropdownModule.forRoot(),
        PerfectScrollbarModule,
        AngularFontAwesomeModule,
        routing,
        MatStepperModule,
        LiveDataView,
        NgxPaginationModule,
        NgbModule,
        HistoryDataViewModel,
        NgbModule,
        MatAutocompleteModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFirestoreModule,
        BsDatepickerModule.forRoot(),
        AutocompleteLibModule
    ],
  providers: [
    HttpTokenService,
    CookieService,
    AuthGuard,
    EcareSecurityService,
    ClientService,
    InterceptableHttp,
    UserPreferenceService,
    DashboardResolve,
    SidebarService,
    LiveDataResolve,
    SensordataComponent,
      BsDatepickerConfig,
    DatePipe,
    appRoutingProviders,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }, {provide: APP_BASE_HREF, useValue: '/'},
  ],
  bootstrap: [AppComponent],
  exports : [],
  entryComponents: [UserModelComponent, UserViewComponent, SensorModelComponent, AddCommissionComponent,
      AppointmentTransactionComponent, PhysicianTransactionComponent, PhysicianDocumentViewComponent,
  PhysicisanReviewCommentsComponent]
})
export class AppModule { }
